import { forwardRef, useId } from 'react';

// Minimal label + input pair. Forwards the ref so react-hook-form's
// register() can attach handlers. Surfaces validation errors inline.
const Input = forwardRef(function Input(
  { label, error, id, className = '', ...rest },
  ref,
) {
  const autoId = useId();
  const inputId = id ?? `in-${autoId}`;
  const describedBy = error ? `${inputId}-err` : undefined;

  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      {label && (
        <label htmlFor={inputId} className="text-sm font-medium text-text">
          {label}
        </label>
      )}
      <input
        ref={ref}
        id={inputId}
        aria-invalid={error ? 'true' : undefined}
        aria-describedby={describedBy}
        className={`rounded-md border bg-bg px-3 py-2 text-text font-body placeholder:text-text-muted focus:outline-none focus:ring-2 focus:ring-accent ${
          error ? 'border-error' : 'border-border focus:border-accent'
        }`}
        {...rest}
      />
      {error && (
        <span id={describedBy} className="text-xs text-error" role="alert">
          {error}
        </span>
      )}
    </div>
  );
});

export default Input;
